module.exports = __webpack_public_path__ + "static/img/news1.d533d59.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/news1.jpg
// module id = SbiI
// module chunks = 1